import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import dayjs from 'dayjs';

import { SessionStorageManager, SiteConfigManager } from '@atlas/core';

import { POPUP_SIGN_UP_DELAY_STORAGE_KEYS } from 'src/common/constants';

function useSafeLocation() {
  try {
    return useLocation();
  } catch {
    return null;
  }
}

function useSafeHistory() {
  try {
    return useHistory();
  } catch {
    return null;
  }
}

export const useSignupPopup = () => {
  const history = useSafeHistory();
  const location = useSafeLocation();
  const enableSignUpDelay = SiteConfigManager.getConfig('config.config.registration.mobile_popup');
  const pathname = location?.pathname;

  const navigate = useCallback(
    url => {
      if (history?.push) {
        history.push(url);
      } else {
        window.location.href = url;
      }
    },
    [history],
  );

  const openSignupPopup = useCallback(() => {
    if (enableSignUpDelay) {
      const nextDayMs = dayjs().add(1, 'd').valueOf();
      const timeoutId = SessionStorageManager.getItem(POPUP_SIGN_UP_DELAY_STORAGE_KEYS.TIMEOUT_ID);
      if (timeoutId) {
        clearTimeout(timeoutId);
        SessionStorageManager.removeItem(POPUP_SIGN_UP_DELAY_STORAGE_KEYS.TIMEOUT_ID);
      }

      SessionStorageManager.setItem(POPUP_SIGN_UP_DELAY_STORAGE_KEYS.NEXT_SHOW, nextDayMs);
    }
    navigate('?cmd=signup');
  }, [enableSignUpDelay, navigate]);

  const closeSignupPopup = useCallback(() => {
    const path = pathname || window.location.pathname;
    navigate(path);
  }, [pathname, navigate]);

  return {
    closeSignupPopup,
    openSignupPopup,
  };
};
